module.exports = __webpack_public_path__ + "img/logo55.6dbc2ecf.png";